import React from "react";
import { motion } from "framer-motion";
import { PROFILE } from "../data/mock";
import HeroPortraitFrame from "../components/portfolio/HeroPortraitFrame";

const timeline = [
  { year: "2026", title: "Independent research & builds", desc: "Shipping production web systems, RAG architectures, and writing on systems engineering." },
  { year: "2024", title: "Applied AI & full-stack development", desc: "Production LLM pipelines, RAG retrieval workflows, and responsive frontend systems." },
  { year: "2022", title: "Informatics, B.Sc.", desc: "Focus: Software engineering, human-computer interaction, and empirical research methodologies." },
  { year: "2020", title: "Commercial web engineering", desc: "Started delivering performant web interfaces and backend services." },
];

export default function About() {
  return (
    <section className="pt-36 sm:pt-40 pb-24 px-6 sm:px-8 lg:px-12">
      <div className="max-w-[1360px] mx-auto">
        <p className="font-mono text-[10.5px] tracking-[0.22em] uppercase text-primary mb-6">About &middot; Philosophy</p>
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <h1 className="text-4xl sm:text-6xl md:text-7xl font-medium tracking-display leading-[1.02]">
              I treat <span className="gradient-purple">software</span> as a craft, and <span className="gradient-purple">research</span> as a habit.
            </h1>
            <p className="mt-8 text-foreground/80 text-[16px] max-w-[60ch] leading-relaxed">
              I am Firza Miftahul Ilmi, a full-stack engineer and applied AI researcher based in Indonesia. My work focuses on bridging academic informatics with scalable web engineering — architecting clean, maintainable systems where specifications come first and performance is non-negotiable.
            </p>
            <p className="mt-4 text-foreground/80 text-[16px] max-w-[60ch] leading-relaxed">
              From designing token-driven design systems in React and Next.js to implementing context-aware RAG retrieval pipelines in Python and FastAPI, I treat every layer of the stack as an intentional craft. When I&apos;m not shipping code, I analyze software architectures, author field notes, and evaluate empirical AI methodologies.
            </p>
          </div>
          <div className="lg:col-span-5 flex justify-center lg:justify-end">
            <HeroPortraitFrame />
          </div>
        </div>

        <div className="mt-24 pt-16 border-t border-border/50">
          <p className="font-mono text-[10.5px] tracking-[0.22em] uppercase text-primary mb-4">Engineering Path</p>
          <h2 className="text-4xl md:text-5xl font-medium tracking-display mb-12">Timeline &amp; <span className="gradient-purple">milestones.</span></h2>
          <ol className="relative border-l border-border/60 ml-3">
            {timeline.map((t, i) => (
              <motion.li
                key={t.year}
                initial={{ opacity: 0, x: -8 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="pl-8 pb-12 relative"
              >
                <span className="absolute -left-[7px] top-1 h-3.5 w-3.5 rounded-full bg-primary shadow-[0_0_18px_rgba(139,92,246,0.7)]" />
                <span className="font-mono text-[11px] tracking-[0.22em] uppercase text-muted-foreground">{t.year}</span>
                <h3 className="mt-1 text-2xl md:text-3xl font-medium tracking-display text-foreground">{t.title}</h3>
                <p className="mt-2 text-foreground/75 max-w-[60ch] text-[15px] leading-relaxed">{t.desc}</p>
              </motion.li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
